<app-sidebar></app-sidebar>

<app-ride-filter
    [maxDistance]="maxDistance()"
    (filterChange)="onFilterChange($event)">
  </app-ride-filter>

@for(ride of rides(); track ride.id){
  <div class="ride-history-container">
    <button class="ride-card" routerLink="/ride-details/{{ ride.id }}">
      <div class="ride-details">
        <div class="ride-header">
          <span class="ride-date">{{ ride.date | date }}</span>
        </div>
        <div class="ride-title">{{ ride.rideName }}</div>
        <div class="ride-stats">
          <span>
            <strong>Udaljenost</strong>
            <span>{{ ride.distance | distanceConverter}}</span>
          </span>
          <span>
            <strong>Vrijeme</strong>
            <span>{{ ride.duration | duration }}</span>
          </span>
          <span>
            <strong>Prosječna brzina</strong>
            <span>{{ ((ride.distance / ride.duration) * 3.6) | number:'1.2-2' }} km/h</span>
          </span>
        </div>
      </div>
      <div class="ride-image">
        <app-mini-map [rideId]="ride.id"></app-mini-map>
      </div>
    </button>
  </div>
}

